import { render } from "./PlatformReport.vue?vue&type=template&id=1323ec6c"
import script from "./PlatformReport.vue?vue&type=script&lang=js"
export * from "./PlatformReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__